export default __webpack_public_path__ + "cfdc43a97d78c07bc7e06309770c4d1a.jpg";